import { CollapsibleSider } from '@/features/layout/_components';
import { useStackSiderClearWhenLocationChange } from '@/features/layout/_hooks/clear-of-sider';
import { type FC, type ReactNode, useCallback, useMemo } from 'react';
import { useAiChatStackSiderView } from '../_hooks/useAiChatStackSiderView';
import { AiChatContent } from './AiChatContent';

export const AiChatCollapsibleSider: FC = () => {
  const aiChatStackSiderView = useAiChatStackSiderView();

  useStackSiderClearWhenLocationChange({ siderType: 'ai-chat' });

  const handleBack = useCallback(() => {
    if (aiChatStackSiderView.list.length > 1) {
      aiChatStackSiderView.pop();
    } else {
      aiChatStackSiderView.clear();
    }
  }, [aiChatStackSiderView]);

  const siderRender: ReactNode = useMemo(() => {
    return (
      <CollapsibleSider
        open={!!aiChatStackSiderView.lastItem}
        canBack={aiChatStackSiderView.list.length > 1}
        onBack={handleBack}
      >
        <AiChatContent />
      </CollapsibleSider>
    );
  }, [aiChatStackSiderView, handleBack]);

  return siderRender;
};
